import { ProviderMedicalRole, UserRole } from '@uplift/types';

import { makeTrackingFunction } from '../use-freshpaint';

export const enum VideoSidebarEvent {
  videoSidebarButton = 'clicked_video_sidebar_button',
  clickedToSelect = 'clicked_to_select',
}

export const enum EventLocation {
  videoSession = 'Video Session'
}

type VideoSidebarButtonClick = {
  eventName: VideoSidebarEvent.videoSidebarButton;
  payload: {
    buttonType: string;
    userType: UserRole;
    medicalRole: ProviderMedicalRole;
  };
};

export const trackVideoSidebarButtonClick =
  makeTrackingFunction<VideoSidebarButtonClick>(VideoSidebarEvent.videoSidebarButton);

type VideoSidebarBooking = {
  eventName: VideoSidebarEvent.clickedToSelect;
  payload: {
    location: EventLocation;
    userType: UserRole;
  };
};

export const trackVideoSidebarBooking = makeTrackingFunction<VideoSidebarBooking>(VideoSidebarEvent.clickedToSelect);
